export class EngagementCategoryDto {
  engagementCategoryId: string;
  code: string;
  displayName: string;
  tier1: string;
  subtype: string;
  description: string;
  reactivationMonths: string;
  displayOrder: string;
  isActive: string;
}
